export default "__VITE_ASSET__B8yBxg_j__"